import {
  CleanActivityEvaluation,
  CleanActivityEvalCriterion,
  parseCleanEvalCriteria,
  calcCleanEvalScore,
} from '../../types/cleanActivity';
import ApprovalStampBox from '../approval/ApprovalStampBox';
import './CleanActivityPanel.css';
import '../product/InspectionFormSheet.css';

interface Props {
  evaluation: CleanActivityEvaluation;
}

function EvalCriteria({ criteria }: { criteria: CleanActivityEvalCriterion[] }) {
  const summary = calcCleanEvalScore(criteria);
  return (
    <div className="ca-items">
      {criteria.map((row, idx) => (
        <div className="ca-item-card" key={row.id}>
          <div className="ca-item-card__head">
            <strong>항목 {idx + 1}</strong>
          </div>
          <div className="ca-item-card__grid">
            <label className="is-wide">
              평가항목
              <textarea rows={2} readOnly value={row.criterion || ''} />
            </label>
            <label>
              배점
              <input readOnly value={row.maxScore ?? ''} />
            </label>
            <label>
              점수
              <input readOnly value={row.score ?? ''} />
            </label>
            <label className="is-full">
              의견
              <textarea rows={2} readOnly value={row.comment || ''} />
            </label>
          </div>
        </div>
      ))}
      {criteria.length === 0 ? <p className="quality-form__hint">등록된 평가 항목이 없습니다.</p> : null}
      {criteria.length > 0 ? (
        <p className="quality-form__hint">
          합계 {summary.sum}/{summary.max}점
        </p>
      ) : null}
    </div>
  );
}

/** 청정활동 평가서 — 원본 상세와 동일한 읽기 전용 양식 */
function CleanActivityEvalView({ evaluation }: Props) {
  const criteria = parseCleanEvalCriteria(evaluation.criteriaJson);
  return (
    <div className="quality-form">
      <div className="ifs-sheet">
        <div className="ifs-sheet__top">
          <div>
            <h4 className="ifs-sheet__title">{evaluation.title || '청정활동 평가서'}</h4>
            <p className="ifs-sheet__subtitle">
              {evaluation.evaluationDate || '-'} · {evaluation.targetArea || '대상구역 미입력'}
            </p>
          </div>
          <ApprovalStampBox
            authorName={evaluation.authorName}
            reviewerName={evaluation.reviewerName}
            approverName={evaluation.approverName}
          />
        </div>
        <div className="ca-meta-grid">
          <label>
            문서번호
            <input readOnly value={evaluation.evaluationNo || '-'} />
          </label>
          <label>
            평가일
            <input readOnly value={evaluation.evaluationDate || '-'} />
          </label>
          <label>
            평가기간
            <input
              readOnly
              value={
                evaluation.periodFrom || evaluation.periodTo
                  ? `${evaluation.periodFrom || '-'} ~ ${evaluation.periodTo || '-'}`
                  : '-'
              }
            />
          </label>
          <label>
            대상 구역
            <input readOnly value={evaluation.targetArea || '-'} />
          </label>
          <label>
            평가자
            <input readOnly value={evaluation.evaluator || '-'} />
          </label>
          <label className="is-span-2">
            점수 / 등급
            <input
              readOnly
              value={`${evaluation.scoreText || '-'}${
                evaluation.gradeText ? ` · ${evaluation.gradeText}` : ''
              }`}
            />
          </label>
        </div>
      </div>

      <div className="quality-form__section">
        <h3>평가 항목</h3>
        <EvalCriteria criteria={criteria} />
      </div>

      <div className="quality-form__section">
        <div className="ca-meta-grid">
          <div className="quality-form__stack is-span-3">
            잘된 점
            <textarea rows={2} readOnly value={evaluation.strengths || ''} />
          </div>
          <div className="quality-form__stack is-span-3">
            개선 필요 사항
            <textarea rows={2} readOnly value={evaluation.improvements || ''} />
          </div>
          <div className="quality-form__stack is-span-3">
            종합 의견
            <textarea rows={3} readOnly value={evaluation.overallComment || ''} />
          </div>
          <div className="quality-form__stack is-span-3">
            비고
            <textarea rows={2} readOnly value={evaluation.remark || ''} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CleanActivityEvalView;
